module.exports = __webpack_public_path__ + "img/Dickson.cbcf223b.jpeg";